module.exports = __webpack_public_path__ + "static/media/BPT.a8ba9e47.png";